"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var translationHelper_1 = require("../../../helpers/translationHelper");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PostDescription = function (_a) {
    var postData = _a.postData;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var descriptionType = translationHelper_1.getDescriptionTypeByLanguage(currentLanguage);
    var resolveDescription = function () {
        var _a;
        return ((_a = postData.sections.about_building[descriptionType]) !== null && _a !== void 0 ? _a : postData.sections.about_building.description);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.description), dangerouslySetInnerHTML: {
            __html: resolveDescription(),
        } }));
};
exports.default = PostDescription;
